import {JsonObject, AbstractModel, JsonProperty, DateOnlyConverter} from '../../core/public-api';
import {UserRole} from './user-role';

@JsonObject('model.user.User')
export class User extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'username')
  username?: string;

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(String, 'firstName')
  firstName?: string;

  @JsonProperty(String, 'lastName')
  lastName?: string;

  @JsonProperty(String, 'phone')
  phone?: string;

  @JsonProperty(String, 'email')
  email?: string;

  @JsonProperty(String, 'apiKey')
  apiKey?: string;

  @JsonProperty([UserRole], 'roles')
  roles?: UserRole[];

  @JsonProperty(String, 'password')
  password?: string;

  @JsonProperty(String, 'pinCode')
  pinCode?: string;

  @JsonProperty([String], 'roleNames')
  roleNames?: string[]

  @JsonProperty(Boolean, 'trackWorkTime')
  trackWorkTime?: boolean;

  @JsonProperty(Boolean, 'onSalary')
  onSalary?: boolean;

  @JsonProperty(Boolean, 'isContractor')
  isContractor?: boolean;

  @JsonProperty(String, 'notes')
  notes?: string;

  @JsonProperty(Number, 'availableVacationTime')
  availableVacationTime?: number;
  availableVacationDays?: number;

  @JsonProperty(Number, 'availableSickTime')
  availableSickTime?: number;
  availableSickHrs?: number;

  @JsonProperty(Number, 'wagePerHour')
  wagePerHour?: number;

  @JsonProperty(Number, 'salary')
  salary?: number;

  @JsonProperty(DateOnlyConverter, 'workStartDate')
  workStartDate?: Date;

  @JsonProperty(String, 'workStartTime')
  workStartTime?: string;

  @JsonProperty(Boolean, 'showInKiosk')
  showInKiosk?: boolean;

  @JsonProperty(Boolean, 'allowMobileClockIn')
  allowMobileClockIn?: boolean;

  @JsonProperty(String, 'shortCode')
  shortCode?: string;

  @JsonProperty(String, 'bgColor')
  bgColor?: string;

  @JsonProperty(Boolean, 'enabled')
  enabled?: boolean;

  @JsonProperty(String, 'punchStatus')
  punchStatus?: string;

  @JsonProperty(Boolean, 'timeCardsClosedBySystem')
  timeCardsClosedBySystem?: boolean;

  @JsonProperty(Number, 'installationPosition')
  installationPosition?: number;

  @JsonProperty(Number, 'vacationAccrualRate')
  vacationAccrualRate?: number;

  @JsonProperty(Number, 'annualVacationHours')
  annualVacationHours?: number;

  adminRole? = false;

  materialManagerRole? = false;

  adminNSales? = false;

  adminNSuperV? = false;

  adminNSuperNSales? = false;

  canSeeProposal? = false;

  engineerNSales? = false;

  installationUser? = false;

  serviceManagerUser? = false;

  serviceDepartmentUser? = false;

}
